import { useState } from "react";

import { ChannelRows } from "./ChannelRows";
import { FinanceGridHeader } from "./FinanceGridHeader";
import type { IFinanceGridChannel } from "./types";
import { channelKey } from "./utils";

/**
 * Grille financière des prix par canal — une ligne par prix, montants alignés
 * à droite (tabular-nums), prix pays inline, historique replié derrière un
 * bouton dans la colonne d'action à droite.
 */
export const FinanceGrid = ({ channels }: { channels: IFinanceGridChannel[] }) => {
    const [openChannels, setOpenChannels] = useState<Set<number | "default">>(new Set());

    const toggleChannel = (key: number | "default") =>
        setOpenChannels((prev) => {
            const next = new Set(prev);
            if (next.has(key)) {
                next.delete(key);
            } else {
                next.add(key);
            }
            return next;
        });

    return (
        <div className="overflow-x-auto">
            <table className="w-full text-left table-fixed">
                <colgroup>
                    <col className="w-3/12" />
                    <col className="w-1/12" />
                    <col className="w-1/12" />
                    <col className="w-3/12" />
                    <col className="w-2/12" />
                    <col className="w-2/12" />
                </colgroup>
                <FinanceGridHeader />
                <tbody>
                    {channels.map((channel) => {
                        const key = channelKey(channel);
                        return (
                            <ChannelRows
                                key={key}
                                channel={channel}
                                isHistoryOpen={openChannels.has(key)}
                                onToggleHistory={() => toggleChannel(key)}
                            />
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
